import './signup.less';
import './telephone_input.less';

import {Link, browserHistory} from 'react-router';
import ResponsiveHeader from '../header/responsive_header';
import ReactDOM from 'react-dom';
const MediaQuery = require('react-responsive');
import React, { Proptypes } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {routerActions} from 'react-router-redux';
import authActions from './auth_actions';
import classNames from 'classnames';
import validate from '../util/validate';
import ShowError from '../components/error/show_error';
import {toTitleCase,join} from '../util/common';
import CONSTANTS from '../common_constants';

class Signup extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      firstName: '',
      email: '',
      password: '',
      passwordFocus: false,
      iconClicked: false,
      validationError : {},
      signupWithFacebookData: {},
      emailMissingInFbLogin : false,
      isLoading : false

    };
    this.inputChange = this.inputChange.bind(this);
    this.signUpWithEmail = this.signUpWithEmail.bind(this);
    this.signupWithFacebook = this.signupWithFacebook.bind(this);
    this.passwordFocus = this.passwordFocus.bind(this);
    this.passwordFocusOut = this.passwordFocusOut.bind(this);
    this.changeInputType = this.changeInputType.bind(this);
  }
  // componentDidMount(){
  //   // this.setState({
  //   //   isFbSDKLoaded : false
  //   // })
  //   // let interval =   setInterval(()=>{
  //   //   if(isFbSDKLoaded)
  //   //   {
  //   //       window.clearInterval(interval);
  //   //       this.setState({
  //   //         isFbSDKLoaded
  //   //       })
  //   //   }
  //   // }, 1000);
  // }
  passwordFocus(){
    this.setState({
      passwordFocus: true
    })
  }

  passwordFocusOut(){
    if(~(!this.state.iconClicked ^  this.setState.passwordFocus)) this.setState({passwordFocus: false});
  }

  eyeIconFocusOut(){
    this.setState({iconClicked: false})
  }

  changeInputType(){
    if(!this.state.iconClicked) this.setState({iconClicked: true});
    ReactDOM.findDOMNode(this.refs.passwordInput).focus();
    const password = document.getElementById('passwordForm');
    if(password.getAttribute("type") == 'password') password.setAttribute('type', 'text');
    else password.setAttribute('type', 'password');
    this.setState({
      passwordFocus: !this.state.passwordFocus
    })
  }

  inputChange(name, event) {
    const stateObj = {};
    stateObj[name] = event.target.value;
    this.setState(stateObj);
  }

  signUpWithEmail(e){

    e.preventDefault();
    const self = this;
    const {state, props} = this;
    const { firstName, email, password, countryCode, passwordHidden } = state;

    let errorMsg = "";

    const validationError = {
      firstName : !validate.name(firstName),
      email : !validate.email(email),
      password: !validate.password(password)
    };

    if (!state.passwordHidden) validationError.password = !validate.password(password);

    const validationMap = {
      firstName : 'First Name',
      email : 'Email',
      password : 'Password'
    };

    const validationFields = [];
    Object.keys(validationError).forEach((key) => {
      if(validationError[key]) validationFields.push(validationMap[key]);
    });

    if(validationFields.length){
      errorMsg = 'Please enter valid '+join(validationFields,(item, idx) => {
        if(validationFields.length === 1) return "";
        if(idx >0 && idx < validationFields.length-1) return ", ";
        else if(idx === validationFields.length-1) return " and ";
        return "";
      })+'.';
    }

    if(errorMsg){
      this.setState({
        error : errorMsg,
        validationError : validationError
      });
      return;
    }

    if(!this.refs.agreeCondition.checked){
      this.setState({
        error : "You must agree to the terms and conditions before registering!",
      });
      return;
    }
    let invitedByUserId;
    if(props.location.query.id)
      invitedByUserId = props.location.query.id
    const paramObj = {
      name: firstName,
      email,
      password,
      deviceTypeId: 3,
      deviceId: 12345,
      invitedByUserId
    };

    props.actions.signupWithEmail(paramObj).then(()=>{
      browserHistory.push('/enter-phoneno');
    }, (err)=>{
      if(err.message === CONSTANTS.notVerifiedUser){
        this.setState({ error : err.message });
        browserHistory.push('/enter-phoneno');
      }
      this.setState({ error : err.error});
    });
  }

  completeSignupWithFacebook(){
    const {props, state} = this;
    let {facebookId,fbToken,userName,profileImageUrl} = state.signupWithFacebookData;
    let email = state.signupWithFacebookData.email;
    if(!state.signupWithFacebookData.email)
    {
      email = state.email
    }
    const paramObj = {
      facebookId,
      fbToken,
      userName,
      email,
      profileImageUrl
    };
    this.setState({
      isLoading : true
    })
    return props.actions.completeSignupWithFacebook(paramObj).then(()=>{
      this.setState({
        isLoading : false
      })
      browserHistory.push('/enter-phoneno');
    }, (error)=>{
      this.setState({
        isLoading : false
      })
      if(error.message === CONSTANTS.notVerifiedUser){
        this.setState({ error : error.message });
        browserHistory.push('/enter-phoneno');
      }
      this.setState({error : error.error});
    });
  }

  signupWithFacebook(e){
    e.preventDefault();
    const {props, state} = this;
    // if(!state.isFbSDKLoaded)
    // {
    //       // do nothing if FB SDK is not loaded
    // }else{
        this.setState({
          isLoading : true
        })
        props.actions.signupWithFacebook().then((data)=>{
          this.setState({
            signupWithMail: true,
            signupWithFacebookData: data,
            isLoading : false
          });
          if(data.email)
            this.completeSignupWithFacebook();
          else
            this.processEmailWhileFacebooklogin(data);
        }, (error) => {
          this.setState({"isLoading" : false})
          this.setState({error: error});
        });
  }

  processEmailWhileFacebooklogin = (data) =>{
    this.setState({
      firstName: this.state.signupWithFacebookData.firstName,
      email : "",
      error : "Please provide your Email ID to proceed",
      emailMissingInFbLogin : true
    })
  }
  signUpWithFacebookWithEmail = (e) =>{
    e.preventDefault();
    this.setState({error:null});
    const self = this;
    const validationError = {
        name: !validate.name(this.state.firstName),
        email: !validate.name(this.state.email)
    };
    const validationMap = {
        name: 'Name',
        email: 'Email ID'
    };
    let errorMsg = "";
    const validationFields = [];
    Object.keys(validationError).forEach((key) => {
        if (validationError[key])
            validationFields.push(validationMap[key]);
        }
    );
    if (validationFields.length) {
        errorMsg = 'Please enter valid ' + join(validationFields, (item, idx) => {
            if (validationFields.length === 1)
                return "";
            if (idx > 0 && idx < validationFields.length - 1)
                return ", ";
            else if (idx === validationFields.length - 1)
                return " and ";
            return "";
        }) + '.';
    }
    if(errorMsg){
      this.setState({
        error : errorMsg,
        validationError : validationError
      });
      return;
    }
    if(!this.refs.agreeCondition.checked){
      this.setState({
        error : "You must agree to the terms and conditions before registering!",
      });
      return;
    }
    this.completeSignupWithFacebook();

  }
  render(){
    const self = this;
    const { props, state } = self;
    const { authState, actions } = props;
    const signupState = authState.signup || {};
    const loader = (<div className = "loader"></div>);
    const {firstName, email, phoneNo, password ,emailMissingInFbLogin} = state;

    let errorMsg = '';
    if(state.error) errorMsg = state.error;
    if(signupState.errorData) errorMsg = signupState.errorData && (signupState.errorData.message || signupState.errorData.error);

    var iconVisibleClass = 'password-icon-wrp btn-click icon-pass-visible';

    state.passwordFocus ? iconVisibleClass += ' icon-pass-active' : iconVisibleClass += ' icon-pass-inactive';

    return(
      <div className="signup-page">
        <MediaQuery query='(max-width: 767px)'>
          <ResponsiveHeader
            logoImagePath = "../public/images/landing/logo_white_saffron.png"
            iconClassName = "user-auth-menu-icon  icon-three-bars"
            responsiveHeaderClassName = "user-auth-default-header" />
        </MediaQuery>
        <MediaQuery query='(min-width: 768px)'>
          <Link to = '/'><div className="awb-logo-wrp"></div></Link>
        </MediaQuery>
        <div className="signup-wrapper">
          {state.error && <ShowError errorMessage = {errorMsg} />}
          <div className="signup-form-wrap">
            <h1 className="page-header text-align-center">Sign Up</h1>
            <div className="form-btn-wrap form-margin">
              {/*
                !emailMissingInFbLogin && <button className = {state.isFbSDKLoaded ? "btn blue" : "btn blue disabled"} onClick = {this.signupWithFacebook}><span className="icon-facebook"></span>{state.isLoading && state.isLoading ? loader : 'Sign up with Facebook'}</button>
              */}
              {
                !emailMissingInFbLogin && <button className = "btn blue" onClick = {this.signupWithFacebook}><span className="icon-facebook"></span>{state.isLoading && state.isLoading ? loader : 'Sign up with Facebook'}</button>
              }
            </div>
            <form className="signup-form" autoComplete="off">
              { !emailMissingInFbLogin && <div className="signup-or-elm text-align-center">or</div>}
              <div className="form-parent-wrp">
                <span className="icon-profile ic-image"></span>
                  <input placeholder="Full Name" className="form-input" type="text" name="firstName" value={firstName} onChange={this.inputChange.bind(self, 'firstName')}/>
              </div>
              <div className="form-parent-wrp">
                <span className="icon-email ic-image"></span>
                  <input placeholder="Email" className="form-input" type="text" autoCapitalize="none"name="email" value={email} onChange={this.inputChange.bind(self, 'email')}/>
              </div>
              {
                !emailMissingInFbLogin &&
                <div className="form-parent-wrp">
                  <span className="icon-pass ic-image"></span>
                    <input placeholder="Password" id="passwordForm" ref="passwordInput"  className="form-input" type="password" name="password" value={password} onChange={this.inputChange.bind(self, 'password')}/>
                  <span className={iconVisibleClass} onClick={this.changeInputType}></span>
                </div>
              }
              <div id="termsAndConditionWrp">
                <input className="checkbox-signup" id="checkboxTerms" type="checkbox" ref="agreeCondition"/>
                <label className="checkbox-details" htmlFor="checkboxTerms"></label>
                <span className="checkbox-terms-wrp" >  <a href="/terms-and-conditions" target="_blank">I agree to AWB’s terms & conditions</a></span>
              </div>
              {
                !emailMissingInFbLogin &&
                <div className="form-btn-wrap">
                  <button className="btn orange" onClick = {this.signUpWithEmail}>{signupState.inProgress && signupState.emailSignup ? loader : 'Create an account'}</button>
                </div>
              }
              {
                emailMissingInFbLogin &&
                <div className="form-btn-wrap">
                  <button className="btn orange" onClick = {this.signUpWithFacebookWithEmail}>{state.isLoading ? loader : 'Create an account using Facebook'}</button>
                </div>
              }
              <div className="text-align-center nav-link-wrp" id="loginNavLink">Already have an account? <Link className="nav-link" to="/login">Log in</Link></div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

//connect Login modal and signup modal with actions and state
const mapStateToProps = (state) => {
  return {
    authState : state.app.auth || {}
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(authActions, dispatch),
    routerActions: bindActionCreators(routerActions, dispatch)
  }
}

Signup = connect(
  mapStateToProps,
  mapDispatchToProps
)(Signup);

export default Signup;



// WEBPACK FOOTER //
// app/auth/signup.jsx